import React from "react";
import Image from "gatsby-image";

import {
  Container,
  Title,
  P,
  ImageContainer
} from "./Components";

const Card = ({ title, image, content }) => {
  return (
    <Container>
      <ImageContainer>
        <Image fluid={image.childImageSharp.fluid} style={{ height: '100%', width: '85%', margin: '0 auto' }} />
      </ImageContainer>
      <Title>{title}</Title>
      <P>{content}</P>
    </Container>
  );
};

export default Card;
